import useAuth from "@/features/auth/hooks/useAuth";

const UserProfileDropdownButton = () => {
  const { user } = useAuth();
  return (
    <>
      <div className="flex px-1 items-center gap-3">
        <div className="size-10 cursor-pointer bg-primary/10 flex items-center justify-center rounded-full">
          <p className="font-bold uppercase text-sm text-primary">
            {user?.username[0]}
            {user?.username[1]}
          </p>
        </div>
        <div className="flex flex-col text-left max-w-28">
          <p className="font-medium truncate text-gray-800">{user?.username}</p>
          <p className="text-sm text-gray-800">{user?.groups?.[0].name}</p>
        </div>
      </div>
    </>
  );
};

export default UserProfileDropdownButton;
